import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "relative h-screen flex overflow-hidden bg-white" }
const _hoisted_2 = { class: "flex flex-col w-0 flex-1 overflow-hidden" }
const _hoisted_3 = { class: "relative overflow-y-auto min-h-screen overflow-x-hidden" }

import { 
    IonPage, 
    IonContent, 
} from '@ionic/vue';

import TopNavigation from '@/partials/TopNavigation.vue';
import SidebarMenu from '@/partials/SidebarMenu.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'AdminLayout',
  props: {
    title: String,
    backUrl: {
        type: String,
        default: null,
    },
    showBack: {
        type: Boolean,
        default: false,
    },
},
  setup(__props) {




return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonPage), null, {
    default: _withCtx(() => [
      _createVNode(_unref(IonContent), {
        fullscreen: true,
        class: ""
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(SidebarMenu),
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("main", _hoisted_3, [
                _createVNode(TopNavigation, {
                  title: __props.title,
                  showBack: __props.showBack,
                  backUrl: __props.backUrl
                }, null, 8, ["title", "showBack", "backUrl"]),
                _renderSlot(_ctx.$slots, "default")
              ])
            ])
          ])
        ]),
        _: 3
      })
    ]),
    _: 3
  }))
}
}

})